/**
 * This file includes all locales
 */
export const LOCALE_US = 'en-US' as const;
export const LOCALE_GB = 'en-GB' as const;
export const LOCALE_DE = 'de-DE' as const;
export const LOCALE_FR = 'fr-FR' as const;
export const LOCALE_IT = 'it-IT' as const;
export const LOCALE_ES = 'es-001' as const;
export const LOCALE_PSEUDO = 'en-PSEUDO' as const;
export const LOCALE_DEBUG = 'en-DEBUG' as const;

const localesList = [
    LOCALE_US,
    LOCALE_GB,
    LOCALE_DE,
    LOCALE_FR,
    LOCALE_IT,
    LOCALE_ES,
    LOCALE_PSEUDO,
    LOCALE_DEBUG,
];

export type Locale = typeof localesList[number];

/**
 * getLocales is used in specific scenarios where we want a list of all locales
 */
export const getLocales = (): Locale[] => localesList;
